import { observer } from 'mobx-react-lite'
import type { TxfJobViewModel } from '../../../txf/TxfJobViewModel'
import { PageSection } from '@/features/jobs/details/components/PageLayout'
import { TxfJobOnboardingCard } from '@/features/jobs/details/tax-type/txf/components/TxfJobOnboardingCard'
import { SectionHeadline } from '@/components/SectionHeadline'

interface TxfJobSectionProps {
  vm: TxfJobViewModel
  sectionHeadline: string
}

export const TxfJobSectionContainer = observer(function TxfJobSectionContainer({
  vm,
  sectionHeadline,
}: TxfJobSectionProps) {
  if (!vm.isReadyForOnboarding) {
    return null
  }

  return (
    <PageSection testId="txf-section">
      <SectionHeadline>{sectionHeadline}</SectionHeadline>
      <TxfJobOnboardingCard onAction={() => vm.viewInTxf()} />
    </PageSection>
  )
})
